import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b35af3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "マイクロチップ検索", -1))

import { ref } from "vue";
import axios from "axios";
import { useDogStore } from "@/stores/dog";
import useToastAlert from "@/composables/tostController";
import { useLoadingController } from "@/composables/loadingController"
import MicrochipInput from "@/components/MicrochipInput.vue";
import { home } from "ionicons/icons";
import { useRouter } from "vue-router";
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
} from "@ionic/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MicrochipInputView',
  setup(__props) {

const dog = useDogStore()

const router = useRouter();
const isValid = ref(true);

const { presentLoading, dismissLoading } = useLoadingController();

function getDogGeneticId(microchipId: any) {
  const re = /^[0-9]{15}$/;
  if (microchipId.match(re)) {
    isValid.value = true;
    presentLoading('検索中...')
    const url = `https://api-bleeder-app-test.anicom-pafe.com/v1/microchip/${microchipId}`;
    axios
      .get(url, {timeout: 10000})
      .then((res) => {
        dismissLoading()
        if("microchip" in res.data) {
        useToastAlert("success", "[Success] 検索成功");
        dog.geneticId = res.data.genetic_id;
        dog.animalName = res.data.animal_name;
        dog.animalKind = res.data.animal_kind;
        dog.animalGender = res.data.animal_gender;
        router.push({
          name: "microchipResult"
        });
      } else {
        useToastAlert( "danger", `なんらかのエラーが発生しました。再度お試しください。`);
      }
      })
      .catch((error) => {
        dismissLoading()
        if(error.response.status == 404) {
          useToastAlert( "danger", "登録されているどうぶつはいません。バックオフィスで登録してください。");
        } else { // 5xxエラーを想定
          useToastAlert( "danger", `なんらかのエラーが発生しました。再度お試しください。`);
        }
      });
  } else {
    isValid.value = false;
    useToastAlert("danger", "15桁の半角英数字で入力してください。");
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), {
                slot: "end",
                "router-link": "/microchip/input",
                "router-direction": "root"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    color: "primary",
                    size: "large",
                    icon: _unref(home)
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("生体管理システム（β）")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(MicrochipInput, {
              class: "ion-padding",
              microchipId: _unref(dog).microchipId,
              "onUpdate:microchipId": _cache[0] || (_cache[0] = ($event: any) => (_unref(dog).microchipId = $event))
            }, null, 8, ["microchipId"]),
            _createVNode(_unref(IonButton), {
              size: "large",
              expand: "block",
              onClick: _cache[1] || (_cache[1] = () => getDogGeneticId(_unref(dog).microchipId))
            }, {
              default: _withCtx(() => [
                _createTextVNode("検索")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})